<template>
    <div class="create-form">
        <select :disabled="this.mode === 'edit'" v-model="localValue.site">
            <option disabled value="">Seite auswählen</option>
            <option :value="opt" v-bind:key="opt.id" v-for="opt in sites">{{opt.name}}</option>
        </select>
        <label>{{localValue.site.type}}</label>
        <table>
            <tr>
                <th>
                </th>
                <th>
                    Font
                </th>
                <th>
                    Color
                </th>
                <th>
                    Background
                </th>
            </tr>
            <tr>
                <td>
                    Fragestellung
                </td>
                <td>
                    <select v-model="localValue.question_font">
                        <option disabled value="">Please select one</option>
                        <option v-bind:key="opt" v-for="opt in options">{{opt}}</option>
                    </select>
                </td>
                <td>
                    <color-input v-model="localValue.question_color"></color-input>
                </td>
                <td>
                    <color-input v-model="localValue.question_background"></color-input>
                </td>
            </tr>
            <tr>
                <td>
                    Ausfüllanweisung
                </td>
                <td>
                    <select v-model="localValue.subtext_font">
                        <option disabled value="">Please select one</option>
                        <option v-bind:key="opt" v-for="opt in options">{{opt}}</option>
                    </select>
                </td>
                <td>
                    <color-input v-model="localValue.subtext_color"></color-input>
                </td>
                <td>
                    <color-input v-model="localValue.subtext_background"></color-input>
                </td>
            </tr>
            <tr>
                <td>
                    Skala
                </td>
                <td>
                    <select v-model="localValue.scale_font">
                        <option disabled value="">Please select one</option>
                        <option v-bind:key="opt" v-for="opt in options">{{opt}}</option>
                    </select>
                </td>
                <td>
                    <color-input v-model="localValue.scale_color"></color-input>
                </td>
                <td>
                    <color-input v-model="localValue.scale_background"></color-input>
                </td>
            </tr>
            <tr>
                <td>
                    Layercontainer
                </td>
                <td>
                </td>
                <td>
                </td>
                <td>
                    <color-input v-model="localValue.container_background"></color-input>
                </td>
            </tr>
        </table>
        <div style="display: flex;justify-content: center">
            <iframe id="my-iframe-test" frameBorder="0" :src="getiFrameUrl()"></iframe>
        </div>
    </div>
</template>

<script>

    import ColorInput from "./ColorInput";
    import {RepositoryFactory} from "../scripts/RepositoryFactory";

    const SiteRepository = RepositoryFactory.get('sites');

    export default {
        name: "LayoutForm",
        components: {
            ColorInput
        },
        props: {
            value: {
                required: true,
                type: Object
            },
            mode: {
                required: false,
                default: 'create'
            }
        },
        data: function () {
            return {
                options: [
                    'Arial',
                    'Times New Roman',
                    'monospace',
                    'sans-serif'
                ],
                sites: [],
                localValue: JSON.parse(JSON.stringify(this.value)),
                skipEmit: false
            }
        },
        mounted() {
            this.getSites();
            this.listenOnPostMessages();
        },
        watch: {
            value: {
                deep: true,
                handler(newVal) {
                    this.skipEmit = true;
                    this.localValue = JSON.parse(JSON.stringify(newVal));
                    this.$nextTick(() => { this.skipEmit = false; });
                }
            },
            localValue: {
                deep: true,
                handler() {
                    if (this.skipEmit) return;
                    this.$emit('input', JSON.parse(JSON.stringify(this.localValue)));
                    document.getElementById('my-iframe-test').src = document.getElementById('my-iframe-test').src
                }
            }
        },
        methods: {
            async getSites() {
                const {data} = await SiteRepository.getAll();
                this.sites = data;
                this.sites.sort(function (a, b) {
                    return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
                });
            },
            siteChanged(site) {
                this.localValue.site = site;
            },
            getiFrameUrl() {
                let args = 'site=' + this.localValue.site.name + '&';
                for (let prop in this.localValue) {
                    if (Object.prototype.hasOwnProperty.call(this.localValue, prop) && typeof this.localValue[prop] === 'string') {
                        args += prop + '=' + this.localValue[prop].replace('#', '%23') + '&';
                    }
                }
                let mobile = this.localValue.site.type === 'MOBILE' ? 'true' : 'false';
                args += 'mobile=' + mobile;
                return encodeURI(`${process.env.VUE_APP_BACKEND_URL}/api/surveys/direct/render?question=An diese Stelle kommt eine zu definierende Fragestellung.Ich denke wir sollten mindestens zwei Zeilen Platz bekommen.&answers=Gut,,,Schlecht,,,Mittel,,,Toll&${args}`);
            },
            listenOnPostMessages() {
                window.addEventListener("message", this.newPostMessage, false);
            },
            newPostMessage(event) {
                if(event.data && typeof event.data === 'string' && event.data.includes('BrandLift')) {
                    let method = event.data.split('::')[1];
                    if(method.includes('Size')) {
                        let w = method.split(':')[1];
                        let h = method.split(':')[2];
                        document.getElementById('my-iframe-test').style.width = w + 'px';
                        document.getElementById('my-iframe-test').style.height = h + 'px';
                    }
                }
            }
        }
    }
</script>

<style scoped>

    iframe {
        display: flex;
        justify-content: center;
    }

    .create-form {
        width: 800px;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .create-form > div {
        margin-bottom: 20px;
    }

    .split-div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .answer-container > input {
        width: 45%;
        margin-bottom: 8px;
    }

    th, tr, td {
        padding: 5px;
    }

    tr {
        background-color: #f5f5f5;
    }

    table {
        border-collapse: separate;
        border-spacing: 10px;
        width: 100%;
    }

</style>